<template>
  <v-autocomplete
    v-model="toEditVal"
    v-bind="field"
    :items="filteredItems"
    :item-text="itemText"
    :item-value="itemValue"
    :label="label"
    :loading="fetching"
    :no-data-text="watch && watchedValue === '' ? `Selecteer eerst een ${toHuman(watch).toLowerCase()}` : 'Geen data beschikbaar'"
    :rules="rules"
    :disabled="disabled || readOnly || fetching"
    @change="$emit('update:toEdit', toEditVal)"
  />
</template>

<script>
import { toHuman } from '@bit/streamline.web.utils'

export default {
  name: 'TextField',
  props: {
    field: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    rules: {
      type: Array,
      default: () => []
    },
    // eslint-disable-next-line vue/require-prop-types
    toEdit: {
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    items: {
      required: true
    },
    watch: {
      type: String,
      isRequired: false,
      default: ''
    },
    // eslint-disable-next-line vue/require-prop-types
    watchedValue: {
      required: false,
      default: ''
    },
    // eslint-disable-next-line vue/require-prop-types
    itemText: {
      default: 'value'
    },
    // eslint-disable-next-line vue/require-prop-types
    itemValue: {
      default: 'id'
    },
    type: {
      type: String,
      required: false,
      default: () => ''
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      toEditVal: this.toEdit,
      filteredItems: Array.isArray(this.items) ? this.items : [],
      refetching: false
    }
  },
  computed: {
    fetching () {
      return this.refetching || this.items === null || this.items === undefined
    }
  },
  watch: {
    toEdit (toEdit) {
      this.toEditVal = toEdit
    },
    items (items) {
      if (Array.isArray(items)) {
        this.filteredItems = items
      }
    },
    watchedValue () {
      this.updateItems()
    },
    disabled () {
      this.updateItems()
    }
  },
  mounted () {
    this.updateItems()
  },
  methods: {
    toHuman,
    // Update the filteredItems array if the 'items' property was given a callback function
    async updateItems () {
      if (typeof this.items !== 'function') { return }
      this.refetching = true
      this.filteredItems = await this.items(this.watchedValue.id || this.watchedValue)
      this.refetching = false
    }
  }
}
</script>

<style scoped>

</style>
